"use client";

import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

export function TableColumnResizeHandle({ active, className, ...props }: ComponentProps<"button"> & { active?: boolean }) {
  return <button type="button" {...props} className={cn(
    "absolute inset-y-0 -right-1 z-20 w-2 cursor-col-resize touch-none",
    "after:absolute after:inset-y-1 after:left-1/2 after:w-px after:-translate-x-1/2 after:bg-transparent",
    "hover:after:bg-border focus-visible:outline-none focus-visible:after:bg-ring",
    active && "after:bg-ring", className,
  )} />;
}
